import {
  type ConfigurationParameters,
  Configuration
} from '@linktivity/ars-neo';
import { createServiceConfig } from '../config';

const BASE_PATH = import.meta.env.VITE_APP_ARS_API as string;

const config = createServiceConfig<
  Configuration,
  ConfigurationParameters | undefined
>({ Configuration, basePath: BASE_PATH });

export default config;
